import { getSupabase } from '@infra/supabase/client';
import type { FormalizacaoLinkForm } from '@modules/formalizacaoLink/formalizacaoLinkModel';

export interface FormalizacaoLink { success: boolean; token?: string; url_path?: string; error?: string }
export interface FormalizacaoLookup { valid: boolean; workspace_name?: string }
export interface FormalizacaoSubmitResult { success: boolean; message?: string; error?: string }

const client = () => {
  const supabase = getSupabase();
  if (!supabase) throw new Error('Supabase não inicializado.');
  return supabase;
};

export const formalizacaoLinkRepository = {
  getLink: async (pipelineId: string): Promise<FormalizacaoLink> => {
    const { data, error } = await client().rpc('get_formalizacao_link', { p_pipeline_id: pipelineId });
    if (error) throw error;
    return data as unknown as FormalizacaoLink;
  },
  lookup: async (token: string): Promise<FormalizacaoLookup> => {
    const { data, error } = await client().rpc('lookup_formalizacao_link', { p_token: token });
    if (error) throw error;
    if (!data) throw new Error('Resposta vazia do lookup_formalizacao_link.');
    return data as unknown as FormalizacaoLookup;
  },
  submit: async (token: string, form: FormalizacaoLinkForm, honeypot?: string): Promise<FormalizacaoSubmitResult> => {
    const { data, error } = await client().rpc('submit_formalizacao_link', {
      p_token: token,
      p_razao_social: form.razaoSocial.trim(),
      p_cnpj: form.cnpj.trim(),
      p_nome_contato: form.nomeContato.trim(),
      p_cargo: form.cargo.trim(),
      p_telefone: form.telefone.trim(),
      p_plano: form.plano.trim(),
      p_modo_contratacao: form.modoContratacao,
      p_vendedor_nome: form.vendedorNome.trim(),
      p_vendedor_telefone: form.vendedorTelefone.trim(),
      p_honeypot: honeypot || undefined,
    });
    if (error) throw error;
    if (!data) throw new Error('Resposta vazia do submit_formalizacao_link.');
    return data as unknown as FormalizacaoSubmitResult;
  },
};
